import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

/**
 * User claims extracted from Azure AD token.
 * Readiness captures tenant context for analysis scoping.
 */
export interface UserClaims {
  userId: string;
  email: string;
  displayName: string;
  tenantId: string;
  roles: string[];
}

interface AuthState {
  user: UserClaims | null;
  isAuthenticated: boolean;
  isLoading: boolean;
  setUser: (user: UserClaims | null) => void;
  clearUser: () => void;
  setLoading: (loading: boolean) => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      user: null,
      isAuthenticated: false,
      isLoading: true,
      setUser: (user) =>
        set({
          user,
          isAuthenticated: !!user,
          isLoading: false,
        }),
      clearUser: () =>
        set({
          user: null,
          isAuthenticated: false,
          isLoading: false,
        }),
      setLoading: (isLoading) => set({ isLoading }),
    }),
    {
      name: 'discovery-auth-storage',
      storage: createJSONStorage(() => localStorage),
      partialize: (state) => ({
        user: state.user,
        isAuthenticated: state.isAuthenticated,
        isLoading: false,
      }),
    }
  )
);
